import { useContext } from "react";
import { MenuCondensedContext } from "../molecules/ResponsiveMenuLayout/MenuCondensedContext";

export function useMenuCondensed(): boolean {
  return useContext(MenuCondensedContext).isCondensed;
}
